import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import AppLoading from "../app-loading/app-loading";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import CashReportSearch from "./cash-report-search";
import CashReportDatatable from "./cash-report-datatable";
import ReceivedAmountTraceDatatable from "./ReceivedAmountTraceDatatable";
import HandoverAmountTraceDatatable from "./HandoverAmountTraceDatatable";
import CollectedAmountTraceDatatable from "./CollectedAmountTraceDatatable";
import { Button } from "primereact/button";
import { CashReportExport } from "./CashReportExport"


const CashReportMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [cashReportData, setcashReportData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastFilterPayload, setLastFilterPayload] = useState<any>(null);
  const [totalCurrentlyHolding, setTotalCurrentlyHolding] = useState<number>(0);
  const [reportTime, setReportTime] = useState<string>("");
  const [dialogVisible, setDialogVisible] = useState(false);
const [selectedUser, setSelectedUser] = useState<{ userID: number; userName: string } | null>(null);
const [searchDates, setSearchDates] = useState<{ startDate: string; endDate: string } | null>(null);
const [handoverDialogVisible, setHandoverDialogVisible] = useState(false);
const [AccountsReceivedcash, setAccountsReceivedcash] = useState<number>(0);
const [collectedDialogVisible, setCollectedDialogVisible] = useState(false);


  const handleSearch = async (filterPayload: any) => {
    setLoading(true);
    setSearchDates({
  startDate: filterPayload.startDate,
  endDate: filterPayload.endDate,
});
    debugger
    setLastFilterPayload(filterPayload);
    try {
      const result = await DeliveryCashService.GetcashReport(filterPayload); // <-- Your new API call
      debugger
      if (Array.isArray(result.reports) && result.reports.length > 0) {
        setcashReportData(result.reports);
        setTotalCurrentlyHolding(result.totalCurrentlyHolding || 0);

        const specialUser = result.reports.find((user: any) => user.userID === 10);
          setAccountsReceivedcash(specialUser?.receivedAmount || 0);
          
         const now = new Date();
          const formatted =
            now.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }) +
            " " +
            now.toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });

      setReportTime(formatted);
      } else {
        // toast.current?.show({
        //   severity: "info",
        //   summary: "No Data",
        //   detail: "No cash collection records found.",
        // });
        setcashReportData([]);
        setTotalCurrentlyHolding(0);
        setAccountsReceivedcash(0);
        setReportTime("");
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch data.",
      });
      setcashReportData([]);
       setReportTime("");
       setTotalCurrentlyHolding(0); 
       setAccountsReceivedcash(0); 
    } finally {
      setLoading(false);
    }
  };

  const handleReceivedAmountClick = (row: any) => {
  if (!searchDates) return;
debugger
  setSelectedUser({ userID: row.userID, userName: row.userName });
  setDialogVisible(true);
};

const handleHandoverAmountClick = (row: any) => {
  if (!searchDates) return;
  setSelectedUser({ userID: row.userID, userName: row.userName });
  setHandoverDialogVisible(true);
};

const handleCollectedAmountClick = (row: any) => {
  if (!searchDates) return;
  setSelectedUser({ userID: row.userID, userName: row.userName });
  setCollectedDialogVisible(true);
};

  return (
    <Suspense fallback={<AppLoading />}>
      <Toast ref={toast} position="top-right" />
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
         <div className="col-12 flex justify-content-between align-items-center">
          <h5 className="ml-1 mb-0">{t("Where is my Cash Report")}</h5>
           <Button
              className="text-black border-round"
              onClick={() => CashReportExport(cashReportData, reportTime)}
              icon="pi pi-file-excel"
              text
              raised
              disabled={!cashReportData.length}
            >
              Export Cash Report
          </Button>
        </div>

        <div className="col-12">
          <CashReportSearch setLoading={setLoading}
           onSearch={handleSearch} 
           onReset={() => {
          setcashReportData([]);
          setTotalCurrentlyHolding(0);
          setReportTime("");
          setAccountsReceivedcash(0);
        }}
           totalCurrentlyHolding={totalCurrentlyHolding}
           AccountsReceivedcash={AccountsReceivedcash}
           />
        </div>

        <div className="col-12">
          <CashReportDatatable
            data={cashReportData}
            loading={loading}
             reportTime={reportTime}
              onReceivedAmountClick={handleReceivedAmountClick}
              onHandoverAmountClick={handleHandoverAmountClick}
              onCollectedAmountClick={handleCollectedAmountClick} 
          />
        </div>
      </div>
 {selectedUser && searchDates && (
  <ReceivedAmountTraceDatatable
    visible={dialogVisible}
    onHide={() => setDialogVisible(false)}
    userID={selectedUser.userID}
    userName={selectedUser.userName}
    startDate={searchDates.startDate}
    endDate={searchDates.endDate}
  />
)}
{selectedUser && searchDates && (
  <HandoverAmountTraceDatatable
    visible={handoverDialogVisible}
    onHide={() => setHandoverDialogVisible(false)}
    userID={selectedUser.userID}
    userName={selectedUser.userName}
    startDate={searchDates.startDate}
    endDate={searchDates.endDate}
  />
  )}
  {selectedUser && searchDates && (
  <CollectedAmountTraceDatatable
    visible={collectedDialogVisible}
    onHide={() => setCollectedDialogVisible(false)}
    userID={selectedUser.userID}
    userName={selectedUser.userName}
    startDate={searchDates.startDate}
    endDate={searchDates.endDate}
  />
)}
      {loading && <AppLoading />}
    </Suspense>
  );
};

export default CashReportMain;
